export default "__VITE_ASSET__ppvYM_a5__"